import React from "react";
import styles from "./footer.module.css";
import { Box } from "@mui/material";

export const Footer = () => {
  return (
    <Box className={styles.footerBar}>
      <p className={styles.footerContent}>© {new Date().getFullYear()} Copigo</p>
    </Box>
  );
};
